import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  LOGIN_SUCCESS,
  LOGOUT,
  SAVE_PREFERENCES_SUCCESS,
  MOBILE_VERIFICATION_SUCCESS,
  TO_BE_VERIFIED_NUMBER,
  UPDATE_ADDRESS_SUCCESS,
  USER_UPDATED,
  SET_USER_ONLINE,
  SAVE_ADDRESS,
  SET_PARTNER_DETAILS,
  PARTNER_VERIFIED,
  PARTNER_DETAILS,
  SECRETCODE_SUCCESS,
  MOBILE_VERIFICATION_FAILED,
} from "../types/types"
import { getParticpantDetails } from "../../utils/helpers"
import localStorage from "redux-persist/es/storage"

const initialState = {
  isAuthenticated: null,
  loading: false,
  user: null,
  mobileToVerify: "",
  partner: null,
  partnerInviteData: null,
  mobileVerificationFailed: null,
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload,
      }
    case PARTNER_VERIFIED:
      return {
        ...state,
        isAuthenticated: false,
        loading: false,
        partnerInviteData: payload,
      }
    case PARTNER_DETAILS:
      return {
        ...state,
        partnerInviteData: payload,
      }
    case REGISTER_SUCCESS:
      localStorage.setItem("token", payload.token)

      return {
        ...state,
        isAuthenticated: payload.token ? true : false,
        loading: false,
        user: payload.user_info,
      }

    case REGISTER_FAIL:
      localStorage.removeItem("token")
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      }

    case LOGIN_SUCCESS:
      if (payload.token) localStorage.setItem("token", payload.token)
      return {
        ...state,
        user: payload.user_info,
        isAuthenticated: payload.token ? true : false,
        loading: false,
      }

    case LOGOUT:
      localStorage.removeItem("token")
      localStorage.removeItem("isPathFromLogin")
      return { ...initialState }
    case SAVE_PREFERENCES_SUCCESS:
      return {
        ...state,
        user: payload,
      }
    case MOBILE_VERIFICATION_SUCCESS:
      return {
        ...state,
        mobileVerificationFailed: false,
      }
    case MOBILE_VERIFICATION_FAILED:
      return {
        ...state,
        mobileVerificationFailed: payload,
      }
    case TO_BE_VERIFIED_NUMBER:
      return {
        ...state,
        mobileToVerify: payload,
      }

    case UPDATE_ADDRESS_SUCCESS:
      return {
        ...state,
        user: payload,
      }
    case USER_UPDATED:
      return {
        ...state,
        user: payload,
      }
    case SET_USER_ONLINE:
      return {
        ...state,
        user: {
          ...state.user,
          online: true,
        },
      }
    case SAVE_ADDRESS:
      return {
        ...state,
        user: payload,
      }
    case SET_PARTNER_DETAILS:
      return {
        ...state,
        partner: getParticpantDetails(state.user, payload),
      }
    case SECRETCODE_SUCCESS:
      return {
        ...state,
        partner: getParticpantDetails(state.user, payload),
      }
    default:
      return state
  }
}
